// extracted by mini-css-extract-plugin
export default {"askWrap":"FaqFrame_askWrap__ZvN2X","open":"FaqFrame_open__dvCsV","qMark":"FaqFrame_qMark__7QK4P","answerWrap":"FaqFrame_answerWrap__YX78Q","aMark":"FaqFrame_aMark__gYNe6"};